import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "context/AuthContext";
import "./styles.scss";

import Button from "components/_base/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import {
  GET_CATEGORIA_ID,
  GET_LIST_CATEGORIA_TIPO,
  GET_CATEGORIAS_SUPERIORES_POR_TIPO,
  SAVE_CATEGORIA,
} from "services/Categoria";
import { Alert } from "react-bootstrap";

const ContentAdminCategoriaRegistro = () => {
  const { showLoader } = useContext(Context);

  const [categoriaLoaded, setCategoriaLoaded] = useState(false);
  const [categoriaTipo, setCategoriaTipo] = useState();
  const [categoriaSuperior, setCategoriaSuperior] = useState([{}]);
  const [categoriaTipos, setCategoriaTipos] = useState([{}]);
  const [erros, setErros] = useState([]);
  const [categoria, setCategoria] = useState({
    categoriaId: 0,
    categoriaSuperiorId: undefined,
    categoriaTipoId: undefined,
    nome: "",
  });

  const location = useLocation();
  const pageQuery = new URLSearchParams(location.search);
  const id = pageQuery.get("id");
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      showLoader(true);

      if (id) {
        const data = await GET_CATEGORIA_ID(id);

        setCategoria(data.value);
        setCategoriaTipo(data.value.categoriaTipo.categoriaTipoId);
      }

      const tipoData = await GET_LIST_CATEGORIA_TIPO();
      setCategoriaTipos(tipoData.value);
      showLoader(false);
    })();
  }, [location.search]);

  useEffect(() => {
    (async () => {
      setCategoriaLoaded(false);

      const data = await GET_CATEGORIAS_SUPERIORES_POR_TIPO(categoriaTipo);
      setCategoriaSuperior(data.value);

      setCategoriaLoaded(true);
    })();
  }, [categoriaTipo]);

  const handleChange = (e) => {
    setCategoria({ ...categoria, [e.target.name]: e.target.value });
  };

  const handleChangeCategoriaTipo = (e) => {
    const categoriaTipoId = parseInt(e.target.value);
    setCategoria({ ...categoria, categoriaTipoId: categoriaTipoId });
    setCategoriaTipo(
      e.target.options[e.target.selectedIndex].getAttribute("categoriatipoid")
    );
  };

  const handleChangeCategoriaSuperior = (e) => {
    const categoriaSuperiorId = parseInt(e.target.value);
    setCategoria({ ...categoria, categoriaSuperiorId: categoriaSuperiorId });
  };

  const handleSave = async () => {
    showLoader(true);

    const errors = validate();
    if (errors.length > 0) {
      setErros(errors);
      showLoader(false);
      return;
    } else {
      setErros([]);
    }

    await SAVE_CATEGORIA(categoria).then((data) => {
      if (data) {
        navigate("/admin/categoria");
      }
    });

    showLoader(false);
  };

  const validate = () => {
    let errors = [];

    if (!categoria.nome) {
      errors.push({ nome: "Nome", message: "Nome é obrigatório" });
    } else if (categoria.nome.length < 3) {
      errors.push({
        nome: "Nome",
        message: "Nome deve ter no mínimo 3 caracteres",
      });
    }

    if (
      !categoria.categoriaTipoId ||
      !Number.isInteger(categoria.categoriaTipoId)
    ) {
      errors.push({ nome: "Tipo", message: "Tipo é obrigatório" });
    }

    if (!categoria.categoriaSuperiorId && categoria.categoriaTipoId !== 1) {
      errors.push({
        nome: "Categoria Superior",
        message: "Categoria superior é obrigatória",
      });
    }

    return errors;
  };

  const loadCategoriaSuperior = () => {
    if (categoriaLoaded === false) {
      return (
        <Form.Select disabled>
          <option>Carregando...</option>
        </Form.Select>
      );
    } else if (categoriaSuperior.length === 0) {
      return (
        <Form.Select disabled>
          <option>Nenhuma categoria superior encontrada</option>
        </Form.Select>
      );
    } else {
      const groupedCategories = categoriaSuperior
        .sort((a, b) =>
          a.categoriaTipo.nome.localeCompare(b.categoriaTipo.nome)
        )
        .reduce((groups, categoria) => {
          const group = categoria.categoriaTipo.nome;
          if (!groups[group]) {
            groups[group] = [];
          }
          groups[group].push(categoria);
          return groups;
        }, {});

      const renderOptions = () => {
        return Object.keys(groupedCategories).map((group) => (
          <optgroup
            className="optgroup-categoria-superior"
            key={group}
            label={group}
          >
            {groupedCategories[group].map((categoria) => (
              <option
                className="option-categoria-superior"
                key={categoria.categoriaId + categoria.nome}
                value={categoria.categoriaId}
              >
                {categoria.nome}
              </option>
            ))}
          </optgroup>
        ));
      };
      return (
        <Form.Select
          name="categoriaSuperiorId"
          disabled={categoriaSuperior.length === 0}
          value={
            categoria.categoriaSuperiorId == null
              ? ""
              : categoria.categoriaSuperiorId
          }
          onChange={handleChangeCategoriaSuperior}
        >
          <option value="">Selecione uma categoria superior</option>
          {renderOptions()}
        </Form.Select>
      );
    }
  };

  return (
    <>
      <div className="admin-categoria-container">
        <div className="admin-header">
          <p>Categoria</p>
        </div>
        <div className="admin-categoria-content-wrapper">
          <div className="admin-categoria-content">
            {/* <hr /> */}
            <Form>
              {erros.length > 0 && (
                <Alert variant="danger">
                  {erros.map((erro) => (
                    <p key={erro.nome}>{erro.message}</p>
                  ))}
                </Alert>
              )}
              <hr />
              <Form.Group as={Row}>
                <Form.Label column className="mb-3">
                  Id
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    name="categoriaId"
                    type="number"
                    placeholder="Id"
                    readOnly
                    disabled
                    value={
                      categoria.categoriaId == null ? "" : categoria.categoriaId
                    }
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column className="mb-3">
                  Nome
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    name="nome"
                    type="text"
                    value={categoria.nome == null ? "" : categoria.nome}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column className="mb-3">
                  Tipo
                </Form.Label>
                <Col sm="10">
                  <Form.Select
                    name="categoriaTipoId"
                    value={
                      categoria.categoriaTipoId === null
                        ? ""
                        : categoria.categoriaTipoId
                    }
                    onChange={handleChangeCategoriaTipo}
                  >
                    <option value="">Selecione uma categoria</option>
                    {categoriaTipos.map((tipo) => (
                      <option
                        categoriatipoid={tipo.categoriaTipoId}
                        key={tipo.categoriaTipoId + tipo.nome}
                        value={tipo.categoriaTipoId}
                      >
                        {tipo.nome}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column className="mb-3">
                  Categoria Superior
                </Form.Label>
                <Col sm="10">{loadCategoriaSuperior()}</Col>
              </Form.Group>
            </Form>
            <Row>
              <Form.Label column className="mb-3" />
              <Col sm="10">
                <Button className="btn-salvar" onClick={handleSave}>
                  Salvar
                </Button>
              </Col>
            </Row>
            <hr />
            <Button
              className={"btn-voltar"}
              onClick={() => navigate("/admin/categoria")}
            >
              &lt; Voltar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentAdminCategoriaRegistro;
